import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectRangePlusIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M10.33 20.25H7.82999C7.41999 20.25 7.07999 20.59 7.07999 21C7.07999 21.41 7.41999 21.75 7.82999 21.75H10.33C10.74 21.75 11.08 21.41 11.08 21C11.08 20.59 10.74 20.25 10.33 20.25Z"
        fill={color}
      />
      <path
        d="M4.5 20.25H3.75V19.5C3.75 19.09 3.41 18.75 3 18.75C2.59 18.75 2.25 19.09 2.25 19.5V21C2.25 21.41 2.59 21.75 3 21.75H4.5C4.91 21.75 5.25 21.41 5.25 21C5.25 20.59 4.91 20.25 4.5 20.25Z"
        fill={color}
      />
      <path
        d="M3 16.92C3.41 16.92 3.75 16.58 3.75 16.17V13.67C3.75 13.26 3.41 12.92 3 12.92C2.59 12.92 2.25 13.26 2.25 13.67V16.17C2.25 16.58 2.59 16.92 3 16.92Z"
        fill={color}
      />
      <path
        d="M3 11.08C3.41 11.08 3.75 10.74 3.75 10.33V7.82999C3.75 7.41999 3.41 7.07999 3 7.07999C2.59 7.07999 2.25 7.41999 2.25 7.82999V10.33C2.25 10.74 2.59 11.08 3 11.08Z"
        fill={color}
      />
      <path
        d="M4.5 2.25H3C2.59 2.25 2.25 2.59 2.25 3V4.5C2.25 4.91 2.59 5.25 3 5.25C3.41 5.25 3.75 4.91 3.75 4.5V3.75H4.5C4.91 3.75 5.25 3.41 5.25 3C5.25 2.59 4.91 2.25 4.5 2.25Z"
        fill={color}
      />
      <path
        d="M13.67 3.75H16.17C16.58 3.75 16.92 3.41 16.92 3C16.92 2.59 16.58 2.25 16.17 2.25H13.67C13.26 2.25 12.92 2.59 12.92 3C12.92 3.41 13.26 3.75 13.67 3.75Z"
        fill={color}
      />
      <path
        d="M7.82999 3.75H10.33C10.74 3.75 11.08 3.41 11.08 3C11.08 2.59 10.74 2.25 10.33 2.25H7.82999C7.41999 2.25 7.07999 2.59 7.07999 3C7.07999 3.41 7.41999 3.75 7.82999 3.75Z"
        fill={color}
      />
      <path
        d="M19.5 3.75H20.25V4.5C20.25 4.91 20.59 5.25 21 5.25C21.41 5.25 21.75 4.91 21.75 4.5V3C21.75 2.59 21.41 2.25 21 2.25H19.5C19.09 2.25 18.75 2.59 18.75 3C18.75 3.41 19.09 3.75 19.5 3.75Z"
        fill={color}
      />
      <path
        d="M21 7.07999C20.59 7.07999 20.25 7.41999 20.25 7.82999V10.33C20.25 10.74 20.59 11.08 21 11.08C21.41 11.08 21.75 10.74 21.75 10.33V7.82999C21.75 7.41999 21.41 7.07999 21 7.07999Z"
        fill={color}
      />
      <path
        d="M21.6 16.05H17.55V12C17.55 11.59 17.21 11.25 16.8 11.25C16.39 11.25 16.05 11.59 16.05 12V16.05H12C11.59 16.05 11.25 16.39 11.25 16.8C11.25 17.21 11.59 17.55 12 17.55H16.05V21.6C16.05 22.01 16.39 22.35 16.8 22.35C17.21 22.35 17.55 22.01 17.55 21.6V17.55H21.6C22.01 17.55 22.35 17.21 22.35 16.8C22.35 16.39 22.01 16.05 21.6 16.05Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectRangePlusIcon.displayName = 'SelectRangePlusIcon';
